var map = {
	"./aprovechar-las-oportunidades.webp": 912,
	"./img-card-1.webp": 1577,
	"./img-card-2.webp": 1578,
	"./img-card-3.webp": 1579,
	"./img-header-mobile.webp": 911,
	"./img-header.webp": 909,
	"./woman-in-computer.webp": 1580
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2978;